import { themeAtom } from './../store/common';
import { RED_ENVELOPE_RECORD, SubscribeType, subscribeType, ThemeEnum } from '@/constants';
import { TabType, isProVipLevel, isStandardVipLevel } from '@/constants/subscription';
import Cookies from 'js-cookie';
import { parse } from 'query-string';
import { getDefaultStore } from 'jotai';
import { curTabAtom, redEnvelopePromotionInfoAtom, userInfoAtom, vipInfoAtom } from '@/store';
import dayjs from 'dayjs';
import { getTheme } from './vip';
const store = getDefaultStore();
/**
 * 获取url中的某个参数
 * @param target
 * @returns value
 */
export function getUrlParam(target: string) {
  // 部分旧版本PC访问的链接有误导致gid和income_source没法正常解析，需做特殊兼容处理
  // https://web-pcxiuxiu.meitu.com/subscription?type=vip&income_source=MTXX-PC?Gid=ebdda209862dbb53af2a54e22abcde20&Rand=3293288
  let result = '';
  // eslint-disable-next-line
  const paramStrAry = window.location.search.split('?').filter((item) => item !== '');
  const params = paramStrAry.reduce((total: any, current: string) => {
    const ary = current.split('&');
    return [...total, ...ary];
  }, []);
  params.forEach((item) => {
    const [key, value] = item.split('=');
    if (key === target) {
      result = value;
    }
  });
  return result;
}

/**
 * 下划线命名转驼峰命名
 * @param s
 * @returns
 */
const underline2Hump = (s: string) => {
  return s.replace(/_(\w)/g, function (all, letter) {
    return letter.toUpperCase();
  });
};

/**
 * JSON对象的key值转换为驼峰式
 */
export const jsonToHump = (obj: any) => {
  if (obj instanceof Array) {
    obj.forEach(function (v, i) {
      jsonToHump(v);
    });
  } else if (obj instanceof Object) {
    Object.keys(obj).forEach(function (key) {
      var newKey = underline2Hump(key);
      if (newKey !== key) {
        obj[newKey] = obj[key];
        delete obj[key];
      }
      jsonToHump(obj[newKey]);
    });
  }
};

/**
 * 订阅内的实验和业务透传的实验信息进行合并
 * @param abInfo 订阅内的ab实验命中信息
 * @returns
 */
export const handleMergeAbinfo = (abInfo: any = {}) => {
  // 通过URL透传的abinfo信息
  let queryAbInfo: any = decodeURIComponent(getUrlParam('ab_info'));
  queryAbInfo = queryAbInfo ? JSON.parse(queryAbInfo) : {};

  const newAbInfo = Object.assign({}, queryAbInfo, abInfo);

  if (Object.keys(newAbInfo).length) {
    newAbInfo.ab_codes = (queryAbInfo.ab_codes || []).concat(abInfo.ab_codes || []);
  }

  return newAbInfo;
};

/**
 * 向地址栏中动态添加参数
 * @param url
 * @param key
 * @param val
 * @returns
 */
export const addParamsToUrl = (url: string, key: string, val: string) => {
  if (!val) {
    return url;
  }
  const re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
  const separator = url.indexOf('?') !== -1 ? '&' : '?';
  if (url.match(re)) {
    return url.replace(re, '$1' + key + '=' + val + '$2');
  } else {
    return url + separator + key + '=' + val;
  }
};

/**
 * 解析URL地址的query参数
 * @returns
 */
export const parseSimpleParams = () => {
  const query = window.location.search.replace(/^\?/, '');
  const params = query.split('&').reduce((obj, cur) => {
    const [key, value] = cur.split('=');
    if (key) obj[decodeURIComponent(key)] = decodeURIComponent(value || '');
    return obj;
  }, {} as Record<string, string>);
  return params;
};

/**
 * 向地址栏中动态删除参数
 * @param key
 * @returns
 */
export const removeParamsToUrl = (key: string) => {
  const params = parseSimpleParams();
  delete params[key];

  const newQuery = Object.keys(params)
    .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
    .join('&');

  // 替换当前 URL（不会刷新页面）
  const { protocol, host, pathname, hash } = window.location;
  const newUrl = `${protocol}//${host}${pathname}${newQuery ? '?' + newQuery : ''}${hash}`;

  window.history.replaceState(null, '', newUrl);
};

let toastDom: HTMLDivElement | null = null;
let timer: any = null;
/**
 * 动态toast提示
 * @param text 提示文案
 * @param parentEle 插入的父级元素
 * @param duration
 */
export const showToast = (text: string, parentEle?: HTMLDivElement | null, duration?: number) => {
  const container = parentEle || document.body;
  if (toastDom) {
    container.removeChild(toastDom);

    timer && clearTimeout(timer);
  }

  const div = document.createElement('div');
  div.innerText = text;
  div.style.whiteSpace = 'nowrap';
  div.style.position = 'absolute';
  div.style.top = '50%';
  div.style.left = '50%';
  div.style.transform = 'translate(-50%, -50%)';
  div.style.background = '#fff';
  div.style.lineHeight = '36px';
  div.style.fontSize = '14px';
  div.style.fontWeight = '400';
  div.style.padding = '0 16px';
  div.style.borderRadius = '12px';
  div.style.boxShadow = '0px 2px 8px 0px rgba(0, 0, 0, 0.5)';
  div.style.color = '#1C1D1F';
  div.style.zIndex = '999';
  container.appendChild(div);
  toastDom = div;

  timer = setTimeout(() => {
    container.removeChild(div);
    toastDom = null;
  }, duration || 3000);
};

const getSuffix = () => {
  const env = process.env.REACT_APP_ENV;
  let suffix = `--${env}`;
  if (env === 'release') {
    suffix = '';
  }
  return suffix;
};

export const getEnterpriseIDKey = () => {
  return `enterprise_id${getSuffix()}`;
};

// 获取enterprise企业标识
export const getEnterpriseID = () => {
  const enterpriseID = Cookies.get(getEnterpriseIDKey()) || '';
  return enterpriseID;
};

// 1 - 购买美豆 2 - 购买会员 3 - 购买美豆套餐 4-抠图张数 5-ailogo单购不限生成次数 6-购买高级会员
export const getSkuType = () => {
  if (subscribeType === SubscribeType.LOGO_UNLIMITED) {
    return 5;
  }

  if (subscribeType === SubscribeType.MEIDOUPACKAGE) {
    return 3;
  }

  if (store.get(curTabAtom) === TabType.PRO_SUB) {
    return 6;
  }

  if (store.get(curTabAtom) === TabType.MEIDOU) {
    return 1;
  }

  if (store.get(curTabAtom) === TabType.CUTOUT) {
    return 4;
  }

  return 2;
};

/**
 * 用户类型
 * @returns 0-非会员，1-普通会员（vip_level 1/2），2-未登陆，3-高级会员
 */
export const getUserType = () => {
  const vipInfo = store.get(vipInfoAtom);
  if (vipInfo?.is_vip && isProVipLevel(vipInfo?.vip_level)) {
    return 3;
  }

  if (vipInfo?.is_vip && isStandardVipLevel(vipInfo?.vip_level)) {
    return 1;
  }

  if (!store.get(userInfoAtom)?.id) {
    return 2;
  }

  return 0;
};

// 从cookie获取pc_gid值
export const getPcGidFromCookie = () => {
  const pcGidStoreKey = `_pc_gid${getSuffix()}`;
  const pcGidVal = Cookies.get(pcGidStoreKey) || '';
  return pcGidVal;
};

// 从cookie获取pc_abCode值
export const getPcAbCodeFromCookie = () => {
  const pcAbCodeStoreKey = `_pc_ab_code${getSuffix()}`;
  const pcAbCodeVal = Cookies.get(pcAbCodeStoreKey) || '';
  return pcAbCodeVal;
};

// 记录红包缓存重置状态
let redEnvelopeResetStatus = false;

// 校验当前是否会触发红包弹窗交互
export const shouldShowRedEnvelopePopup = () => {
  const userInfo = store.get(userInfoAtom);
  const redEnvelopePromotionInfo = store.get(redEnvelopePromotionInfoAtom);

  const redEnvelopePromotionListLength =
    redEnvelopePromotionInfo?.redEnvelopePromotionList.length || 0;
  const triggerPeriodDuration = redEnvelopePromotionInfo?.triggerPeriodDuration || 0;
  const triggerFrequency = redEnvelopePromotionInfo?.triggerFrequency || 0;
  // 无红包优惠券
  if (!redEnvelopePromotionListLength) return false;

  try {
    let couponTriggerRecord: any = window.localStorage.getItem(RED_ENVELOPE_RECORD);
    // 目前只考虑 N 天触发 Y 次的情况
    if (couponTriggerRecord) {
      const list: any[] = JSON.parse(couponTriggerRecord);
      const info = list.find((item) => item.uid === userInfo?.id);

      if (!info) {
        // 账号没有记录过，即首次进入
        return true;
      }

      const { lastTime = Date.now(), count = 0 } = info;

      if (dayjs(dayjs(lastTime).add(triggerPeriodDuration - 1, 'day')).isBefore(dayjs(), 'day')) {
        // 周期外，重置重新计算
        redEnvelopeResetStatus = true;
        return true;
      }

      // 次数
      if (count < triggerFrequency) {
        redEnvelopeResetStatus = false;
        // 周期内次数叠加
        return true;
      }

      return false;
    }

    redEnvelopeResetStatus = true;
    // 首次无缓存数据
    return true;
  } catch (e) {
    console.log(e, 'shouldShowRedEnvelopePopup==========');
    return true;
  }
};

// 更新红包弹窗触发缓存数据
export const updateLocalRedEnvelopRecord = () => {
  const userInfo = store.get(userInfoAtom);

  const obj = {
    count: 1,
    lastTime: Date.now(),
    uid: userInfo?.id || 0,
  };

  let list: any[] = [];

  try {
    let couponTriggerRecord: any = window.localStorage.getItem(RED_ENVELOPE_RECORD);
    if (couponTriggerRecord) {
      list = JSON.parse(couponTriggerRecord);
      const info = list.find((item) => item.uid === userInfo?.id);

      if (info) {
        const { count = 0 } = info;
        obj.count = count + 1;
      }
    }

    // 剔除之前的数据
    list = list.filter((item) => item.uid !== userInfo?.id);

    // 添加最新的数据
    list.push(obj);

    window.localStorage.setItem(RED_ENVELOPE_RECORD, JSON.stringify(list));
  } catch (e) {}
};

export const parseQueryString = (str: string): Record<string, string | number> => {
  const parsed = parse(str); // parsed 类型为 ParsedQuery<string>
  return Object.entries(parsed).reduce<Record<string, string | number>>((acc, [key, value]) => {
    const raw = Array.isArray(value) ? value[0] : value;
    acc[key] =
      typeof raw === 'string' && !isNaN(raw as any) ? Number(raw) : (raw as string | number);
    return acc;
  }, {});
};

// 从cookie中读取mtxx_web_gid
export const getMtxxWebGidValue = () => {
  const env = process.env.REACT_APP_ENV;
  let suffix = `-${env}`;
  if (env === 'release') {
    suffix = '';
  }
  const key = `mtxx_web_gid${suffix}`;
  return Cookies.get(key) || '';
};

export const handleTheme = async () => {
  const str = await getTheme();
  store.set(themeAtom, str as ThemeEnum);
};
